export class StudentBellScheduleModel {
	label: string;
	description: string;
	periods: string[];
	files: unknown;
}
